<template>
<div class="chapter">
<div class="inner_page">
<div class="toc" id="toc">
<h1 class="chapter"><a id="piv"></a><a id="pv"></a><em>Table of Contents</em></h1>
<p class="nonindent1"><a class="hlink" href="#/OEBPS/9780811740111_epub_frw_r1.htm"><em>Foreword</em></a></p>
<p class="nonindent1"><a class="hlink" href="#/OEBPS/9780811740111_epub_itr_r1.htm"><em>Introduction</em></a><br/><br/></p>
<p class="nonindent"><a class="hlink" href="#/OEBPS/9780811740111_epub_c01_r1.htm">Schoolhouse Rocks</a></p>
<p class="nonindent"><a class="hlink" href="#/OEBPS/9780811740111_epub_c02_r1.htm">Shoot Down</a></p>
<p class="nonindent"><a class="hlink" href="#/OEBPS/9780811740111_epub_c03_r1.htm">Not Ready to Be an Angel</a></p>
<p class="nonindent"><a class="hlink" href="#/OEBPS/9780811740111_epub_c04_r1.htm">Call Sign: “Krusty”</a></p>
<p class="nonindent"><a class="hlink" href="#/OEBPS/9780811740111_epub_c05_r1.htm">The Little Bird that Could</a></p>
<p class="nonindent"><a class="hlink" href="#/OEBPS/9780811740111_epub_c06_r1.htm">Little Dee with a Big Gun</a></p>
<p class="nonindent"><a class="hlink" href="#/OEBPS/9780811740111_epub_c07_r1.htm">Who Wants to Be Average?</a></p>
<p class="nonindent"><a class="hlink" href="#/OEBPS/9780811740111_epub_c08_r1.htm">Taking Command of the Herk</a></p>
<p class="nonindent"><a class="hlink" href="#/OEBPS/9780811740111_epub_c09_r1.htm">Live from Iraq</a></p>
<p class="nonindent"><a class="hlink" href="#/OEBPS/9780811740111_epub_c10_r1.htm">The Healers of the Guardians of Peace</a></p>
<p class="nonindent"><a class="hlink" href="#/OEBPS/9780811740111_epub_c11_r1.htm">Roll with It</a><br/><br/></p>
<p class="nonindent1"><a class="hlink" href="#/OEBPS/9780811740111_epub_epi_r1.htm"><em>Epilogue</em></a></p>
<p class="nonindent1"><a class="hlink" href="#/OEBPS/9780811740111_epub_aft_r1.htm"><em>Afterword</em></a></p>
<p class="nonindent1"><a class="hlink" href="#/OEBPS/9780811740111_epub_ack_r1.htm"><em>Acknowledgments</em></a></p>
<p class="nonindent1"><a class="hlink" href="#/OEBPS/9780811740111_epub_ind_r1.htm"><em>Index</em></a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780811740111_epub_toc_r1.vue?705f17ea